import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const FTS_STAGED_USERS = gate('FTS:StagedUsers');
export const M1_HUB_PAGES = gate('SSM:PricingPageV2:M1HubPages');
export const M2_BUNDLE_PAGES = gate('SSM:PricingPageV2:M2BundlePages');
export const M3_SMART_CRM_PAGES = gate('SSM:PricingPageV2:M3SmartCRMPages');
export const SLASHING_PRICES = gate('SSM:SlashingPrices');